/* The cart is the durable source of truth for case one, including custom artwork.
   Session state contains only its line key, never a second copy of photo data. */
(function () {
  'use strict';
  var key = 'robopixel:pair:first-case:v1';
  var initial = document.querySelector('[data-pair-cart-state]');
  var cartState = initial ? JSON.parse(initial.textContent) : { canComplete: false };
  var refreshQueue = Promise.resolve();
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function read() {
    try {
      var state = JSON.parse(sessionStorage.getItem(key) || 'null');
      return state && typeof state.line === 'string' ? state : null;
    } catch (_) { return null; }
  }
  function save(line, item) {
    if (!line) return false;
    var existing = read();
    var state = item ? { line: line, variant: String(item.variant_id || item.id), group: (item.properties || {})['_RoboPixel Offer Group'], time: Date.now() }
      : existing && existing.line === line ? existing : { line: line, time: Date.now() };
    try { sessionStorage.setItem(key, JSON.stringify(state)); return true; }
    catch (_) { return false; }
  }
  function signal() { paintCouponCopy(); window.dispatchEvent(new Event('robopixel:pair-context')); }
  function hasCoupons() { return (cartState.couponCodes || []).some(Boolean); }
  function copy(key, values) { return window.RoboPixelCoupons ? window.RoboPixelCoupons.text(key, values) : cartState.changedMessage; }
  function displayName(name) { return hasCoupons() && window.RoboPixelCoupons ? copy('another') : name; }
  function displayPrice(price) { return hasCoupons() && window.RoboPixelCoupons ? copy('maximum', { price: price }) : price; }
  function paintCouponCopy() {
    if (!window.RoboPixelCoupons) return;
    document.querySelectorAll('[data-pair-coupon-title], [data-pair-coupon-tag], [data-pair-coupon-price]').forEach(function (node) {
      if (!node.dataset.originalHtml) node.dataset.originalHtml = node.innerHTML;
      if (!hasCoupons()) node.innerHTML = node.dataset.originalHtml;
      else if (node.hasAttribute('data-pair-coupon-price')) node.textContent = copy('maximum', { price: node.dataset.price });
      else node.textContent = copy(node.hasAttribute('data-pair-coupon-tag') ? 'coupon' : 'another');
    });
    document.querySelectorAll('[data-coupon-offer-notice]').forEach(function (node) {
      node.hidden = !hasCoupons();
      var pack = document.querySelector('[data-customizer-offer][value="ecosystem"]:checked, [data-rp-offer][value="ecosystem"]:checked');
      node.textContent = copy(cartState.canComplete && !pack ? 'notice' : 'baseNotice');
    });
  }
  function refresh() {
    // Liquid owns tag eligibility; cart.js does not expose product tags.
    // Serialize reads so a response from before a mutation cannot win later.
    refreshQueue = refreshQueue.catch(function () {}).then(async function () {
      var response = await fetch(root + '?sections=rp-pair-cart-state', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error(cartState.changedMessage);
      var sections = await response.json();
      var doc = new DOMParser().parseFromString(sections['rp-pair-cart-state'] || '', 'text/html');
      var node = doc.querySelector('[data-pair-cart-state]');
      if (!node) throw new Error(cartState.changedMessage);
      var next = JSON.parse(node.textContent);
      // Keep static quote metadata from the page during a staggered theme
      // deployment (or a cached section response). Eligibility is always fresh.
      if (!next.discountTitle) next.discountTitle = cartState.discountTitle;
      if (!Number.isFinite(next.savingCents)) next.savingCents = cartState.savingCents;
      var changed = JSON.stringify(next) !== JSON.stringify(cartState);
      cartState = next;
      if (changed) signal();
      else paintCouponCopy();
      return cartState;
    });
    return refreshQueue;
  }
  function guide() {
    var drawer = document.querySelector('cart-drawer.active');
    var chooser = (drawer || document.getElementById('main-cart-footer') || document).querySelector('case-pair-offer');
    if (!chooser) return;
    var state = read();
    if (state) chooser.dataset.firstKey = state.line;
    chooser.hidden = false;
    var details = chooser.querySelector('details');
    var custom = chooser.dataset.preferCustom === 'true' && chooser.querySelector('[data-case-pair-custom]');
    if (details) details.open = !custom;
    var message = chooser.querySelector('[data-case-pair-first-added]');
    if (message) message.hidden = !!custom;
    var select = chooser.querySelector('select');
    if (!custom && select) { select.value = ''; chooser.syncAvailability(); }
    chooser.scrollIntoView({ block: 'nearest', behavior: 'instant' });
    // A newly opened details panel needs a layout before its control can take
    // focus. The direct custom action is already visible on the custom route.
    var next = custom || select;
    if (next) requestAnimationFrame(function () { if (next.isConnected) next.focus({ preventScroll: true }); });
  }
  var adding = false;
  var choosing = false;
  function activeCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable === true; }).map(function (d) { return d.code.toUpperCase(); }).sort();
  }
  function quoteSignature(cart) { return JSON.stringify([cart.currency, cart.total_price, composition(cart.items), activeCodes(cart)]); }
  async function addChecked(body, expectedSecond, incrementCents) {
    if (choosing) throw new Error(cartState.changedMessage);
    try { return await addAttempt(body, expectedSecond, incrementCents); }
    catch (error) {
      if (!error.quote || !window.RoboPixelCoupons) throw error;
      choosing = true;
      var decision;
      try { decision = await window.RoboPixelCoupons.confirmQuote(error.quote); }
      finally { choosing = false; }
      if (decision === true) return addAttempt(body, expectedSecond, error.quote.increment, error.quote);
      if (decision === 'cart') {
        if (window.RoboPixelLoadCart) await window.RoboPixelLoadCart();
        if (window.RoboPixelCartSync) await window.RoboPixelCartSync.refresh();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.open) drawer.open();
      }
      throw new Error(copy('conflict'));
    }
  }
  function lineIdentity(item) {
    return JSON.stringify([String(item.variant_id || item.id), Object.entries(item.properties || {}).sort()]);
  }
  function composition(items, operation) {
    var counts = {};
    items.filter(function (item) { return !operation || (item.properties || {})._RoboPixel_Add_ID !== operation; }).forEach(function (item) {
      var identity = lineIdentity(item);
      counts[identity] = (counts[identity] || 0) + item.quantity;
    });
    return JSON.stringify(Object.entries(counts).sort());
  }
  async function getCart() {
    var response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(cartState.changedMessage);
    return response.json();
  }
  async function sectionsFor(body) {
    if (!body.sections) return {};
    var url = new URL(body.sections_url || location.pathname, location.origin);
    url.searchParams.set('sections', Array.isArray(body.sections) ? body.sections.join(',') : body.sections);
    var response = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
    if (!response.ok) throw new Error(cartState.changedMessage);
    return response.json();
  }
  // Ajax additions are not transactional. Give this operation its own line(s),
  // validate before the write, then verify Shopify's actual allocation and net
  // cart increase. A failed quote removes only these lines, never an earlier
  // design. A lost add response is reconciled instead of repeating the POST.
  async function addAttempt(body, expectedSecond, incrementCents, quote) {
    if (adding || (window.RoboPixelCoupons && window.RoboPixelCoupons.isBusy())) throw new Error(cartState.changedMessage);
    adding = true;
    var operation = crypto.randomUUID();
    var submitted = false;
    var before;
    var message = cartState.changedMessage;
    try {
      await window.RoboPixelPairJourney.validate(expectedSecond);
      before = await getCart();
      if (quote && quoteSignature(before) !== quote.signature) throw new Error(copy('changed'));
      var items = body.items || [{ id: body.id, quantity: body.quantity || 1, properties: body.properties }];
      items = items.map(function (item) {
        return Object.assign({}, item, { properties: Object.assign({}, item.properties, { _RoboPixel_Add_ID: operation }) });
      });
      var request = Object.assign({}, body, { items: items });
      delete request.id; delete request.quantity; delete request.properties;
      var result;
      var addError;
      submitted = true;
      try {
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(request)
        });
        result = await response.json();
        if (!response.ok) addError = new Error(result.description || result.message || message);
      } catch (error) { addError = error; }
      var after = await getCart();
      var added = after.items.filter(function (item) { return (item.properties || {})._RoboPixel_Add_ID === operation; });
      if (!added.length) throw addError || new Error(message);
      var expectedQuantity = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      var actualQuantity = added.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      var unchanged = composition(before.items) === composition(after.items, operation);
      var saving = function (cart) {
        var orderSaving = (cart.cart_level_discount_applications || []).reduce(function (sum, discount) {
          return sum + (discount.title === cartState.discountTitle ? discount.total_allocated_amount : 0);
        }, 0);
        return cart.items.reduce(function (sum, item) {
          return sum + (item.line_level_discount_allocations || []).reduce(function (total, allocation) {
            return total + (allocation.discount_application.title === cartState.discountTitle ? allocation.amount : 0);
          }, 0);
        }, orderSaving);
      };
      var codes = activeCodes(before);
      var retainedCoupon = codes.length > 0 && JSON.stringify(codes) === JSON.stringify(activeCodes(after));
      var increment = after.total_price - before.total_price;
      var safeItems = actualQuantity === expectedQuantity && unchanged;
      var pairSaving = saving(after) - saving(before) >= cartState.savingCents;
      var correctPrice = !expectedSecond || (after.currency === 'EUR' &&
        Number.isFinite(incrementCents) && increment <= incrementCents && (pairSaving || retainedCoupon));
      if (!safeItems || !correctPrice) {
        var problem = new Error(retainedCoupon ? copy('conflict') : message);
        // Roll back first. A higher quote is never left in the basket without
        // explicit consent; accepting it reruns all checks against this snapshot.
        if (!quote && safeItems && retainedCoupon && after.currency === 'EUR' && Number.isFinite(incrementCents) && increment > incrementCents) {
          problem.quote = { increment: increment, total: after.total_price, signature: quoteSignature(before) };
        }
        throw problem;
      }
      // Shopify's bundled add sections can precede discount recalculation.
      // Only use sections fetched after cart.js confirms the final totals.
      var sections = await sectionsFor(body);
      window.dispatchEvent(new Event('robopixel:cart-changed'));
      return Object.assign({}, result && !addError ? result : { items: added }, { sections: sections });
    } catch (error) {
      if (submitted) {
        try {
          var current = await getCart();
          var updates = {};
          current.items.forEach(function (item) {
            if ((item.properties || {})._RoboPixel_Add_ID === operation) updates[item.key] = 0;
          });
          if (Object.keys(updates).length) {
            var rollback = await fetch(root + 'cart/update.js', {
              method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
            if (!rollback.ok) throw new Error(message);
            var restored = await getCart();
            if (restored.items.some(function (item) { return (item.properties || {})._RoboPixel_Add_ID === operation; })) throw new Error(message);
          }
        } catch (_) {
          // Do not enable a blind retry when the server outcome is unknown.
          window.location.assign(root + 'cart');
          throw new Error(message);
        }
        window.dispatchEvent(new Event('robopixel:cart-changed'));
      }
      throw error instanceof Error ? error : new Error(message);
    } finally { adding = false; }
  }
  window.RoboPixelPairJourney = {
    addChecked: addChecked,
    isAdding: function () { return adding || choosing; },
    hasCoupons: hasCoupons,
    displayName: displayName,
    displayPrice: displayPrice,
    paintCouponCopy: paintCouponCopy,
    isSecond: function () { return !!cartState.canComplete; },
    firstKey: function () { return cartState.firstKey; },
    caseModels: function () { return cartState.caseModels || []; },
    refresh: refresh,
    decorate: function (scope, enabled, regularPrice, secondPrice) {
      paintCouponCopy();
      var second = !!enabled && !!cartState.canComplete;
      scope.querySelectorAll('[data-pair-normal]').forEach(function (node) { node.hidden = second; });
      scope.querySelectorAll('[data-pair-second]').forEach(function (node) { node.hidden = !second; });
      var pair = scope.querySelector('[data-pair-start-option]');
      if (pair) pair.hidden = second;
      var alternative = scope.querySelector('[data-pair-alternative]');
      if (alternative) {
        var packSelected = !!alternative.querySelector('input:checked');
        if (alternative.dataset.second !== String(second)) alternative.open = !second || packSelected;
        if (packSelected) alternative.open = true;
        alternative.dataset.second = String(second);
        alternative.dataset.packSelected = String(packSelected);
      }
      var price = scope.querySelector('[data-pair-case-price]');
      if (price) {
        price.innerHTML = second ? displayPrice(secondPrice) : regularPrice;
        if (second) {
          var strike = document.createElement('s');
          strike.className = 'rp-offer__regular-price';
          strike.innerHTML = regularPrice;
          price.appendChild(strike);
        }
      }
      return second;
    },
    prepareCustom: function (line) { return save(line); },
    start: function (data) {
      var first = data.items ? data.items[0] : data;
      save(first && first.key, first);
      setTimeout(guide, 120);
    },
    guide: guide,
    cancel: function () {
      try { sessionStorage.removeItem(key); } catch (_) {}
      var url = new URL(location.href); url.searchParams.delete('pair_second');
      history.replaceState({}, '', url);
      signal();
    },
    validate: async function (expectedSecond) {
      var before = typeof expectedSecond === 'boolean' ? expectedSecond : this.isSecond();
      await refresh();
      if (before !== this.isSecond()) throw new Error(cartState.changedMessage);
      return true;
    }
  };
  window.RoboPixelPairJourney.ready = (async function () {
    await refresh().catch(function () {});
    if (new URL(location.href).searchParams.get('choose_second') === '1') setTimeout(guide, 150);
  })();
  function backgroundRefresh() { refresh().catch(function () {}); }
  window.addEventListener('robopixel:cart-changed', backgroundRefresh);
  window.addEventListener('pageshow', backgroundRefresh);
  window.addEventListener('focus', backgroundRefresh);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) backgroundRefresh(); });
  function subscribeToCart() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, backgroundRefresh);
  }
  // Deferred scripts run while readyState is already "interactive"; the
  // pub/sub script appears later in the head and may not have executed yet.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribeToCart();
  else document.addEventListener('DOMContentLoaded', subscribeToCart, { once: true });
})();
